<app-dynamic-form
  [formProperties]="formProperties"
  [formGroup]="formGroup"
  [fieldFilterString]="searchString"
></app-dynamic-form>
